// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mds-tag-container__cwp{display:inline-block;font-size:0;margin-bottom:-8px}.mds-tag-container__cwp .mds-tag__cwp{margin-bottom:8px}.mds-tag-container__cwp .mds-tag__cwp:not(:last-child){margin-right:8px}", ""]);
// Exports
exports.locals = {
	"mds-tag-container": "mds-tag-container__cwp",
	"mds-tag": "mds-tag__cwp"
};
module.exports = exports;
